import { useCategoryTreeItem } from '../categoryTree';
import { useInfiniteQueryWithLimit } from '../hooks/useInfiniteQueryWithLimit';
import { queryKeys } from '../queryKeys';

import { fetchRentals } from './fetchRentals';
import { RentalAsset } from './types';

type UseRentalsProps = {
  pageSize: number;
  referenceId: string;
};

export function useRentals({ referenceId, pageSize }: UseRentalsProps) {
  const category = useCategoryTreeItem(referenceId);

  return useInfiniteQueryWithLimit<RentalAsset>({
    queryKey: category ? queryKeys.rentals(referenceId, pageSize) : queryKeys.disabled,
    queryFn: ({ pageParam }) => {
      return fetchRentals({
        pageSize,
        pageIndex: pageParam,
        ksql: category?.aggregatedKSQL,
      });
    },
    enabled: Boolean(category),
    pageSize,
  });
}
